import React from 'react'
import "react-datetime/css/react-datetime.css";
import { ErrorMessage, FormikProps } from 'formik'
import { Attributes, Label, Validation } from 'app/modules/tp/builders/FormBuilder';
import DateRangeInput from './DatetimeRangeInput';
import { Actions } from 'app/modules/tp/components/Modal/ModalEntity';
import SelectInputField, { Options } from "./SelectInputField";


export type AbsencesRangeInputObj<T> = {
    hoursRange?: boolean,
    dateRange?: boolean,
    type: "absencesdaterange" | "absencestimerange",
    key: keyof T,
    selectOpt: Options,
    placeholder?: string,
    isRequired?: boolean,
    attributes?: Attributes,
} & Attributes & Validation & Label


export type DateRangeInputFieldProps<T> = {
    formik: FormikProps<T>,
    inputObj: AbsencesRangeInputObj<T>
    actions: Actions<T>,
    onChange?: (e: T) => void,
}


const AbsencesRangeInputField = <T,>({ formik, inputObj, onChange, actions }: DateRangeInputFieldProps<T>) => {

    const isRequiredField = (inputObj: AbsencesRangeInputObj<T>) => {
        return inputObj.validation?.spec?.presence === 'required'
    }

    const stateChange = (e: T) => {
        formik.setFieldValue(inputObj.key as string, e);
        onChange && onChange(e);
    };

    return (<>
        {inputObj.label && (
            <label className={`fw-bold fs-6 mb-2 ${isRequiredField(inputObj) ? "required" : ""} `}>
                {inputObj.label}
            </label>
        )}

        <DateRangeInput
            onChange={stateChange}
            type={(inputObj.type === 'absencesdaterange') ? 'daterange' : 'timerange'}
            name={inputObj.key as string}
            value={formik.getFieldProps(inputObj.key as string)?.value}
            autoComplete='off'
            disabled={formik?.isSubmitting}
        />

        <SelectInputField
            formik={formik}
            inputObj={{ ...inputObj, key: `${inputObj.key}.reason` as keyof T, type: 'select', options: inputObj.selectOpt }}
            onChange={onChange}
            actions={actions}
        />

        {formik?.touched[inputObj.key] && formik.errors[inputObj.key] && (
            <ErrorMessage name={inputObj.key as string}
                render={(error: string) => (
                    <div className='fv-plugins-message-container'>
                        <div className='fv-help-block'>
                            <span role='alert'>{error}</span>
                        </div>
                    </div>
                )} />
        )}

    </>
    )
}
export default AbsencesRangeInputField;
